import type { I18n } from "vue-i18n";
import { createI18n } from "vue-i18n";
import { useLocalizationStore } from "@xlabmedical/medic-web-framework";
import { webRgLocaleProps } from "@/util/WebRgLocalizationPlugin";

let _i18n: I18n | null = null;

export function getI18n() {
    if (!_i18n) {
        const localizationStore = useLocalizationStore();
        _i18n = createI18n(webRgLocaleProps(localizationStore));
    }
    return _i18n;
}
